import styled from 'styled-components';

const StyledAccessErrorPageExternalForLti = styled.div`
    a {
        display: none;
    }
`;

export default StyledAccessErrorPageExternalForLti;
